var CHECKOUT = (function($, window, document, undefined){
  var pub = {};
  var orderDeadlineHours = 48;
  var storageKey = 'b48:selectedPackage';
  var customerStorageKey = 'b48:orderCustomer';
  var paymentStorageKey = 'b48:orderPayment';
  var STRIPE_PUBLISHABLE_KEY = 'pk_live_51ShsFXE7Bpx4727HBTmTavA0UWnvkjP8a70jin3qVFiOej8pMcNmLN0WymkE8LrF26QnHq0pIQs5lz6lfBqcLYbq00AXlrsaiB';

  var paymentCompleted = false;
  var paymentListenerBound = false;
  var litboxOpenTime = null;
  var deadlineInterval = null;
  var forceLitboxClose = false;
  var isOrderLitboxOpen = false;
  var orderClosePrompt = 'Are you sure you want to close the order form?';
  var orderBeforeUnloadBound = false;
  var step1Validator = null;
  var uiBound = false;
  var leadCaptureRequested = false;
  // Update these to new Stripe price IDs when changing prices in Stripe.
  var PRICE_IDS = {
    basic: 'price_1SwDh2E7Bpx4727HBrkzXj3f',
    standard: 'price_1SmtwdE7Bpx4727HBnNmbUxu',
    max: 'price_1SmtwhE7Bpx4727HKFxKmfMU',
    addOnStandard: 'price_1Sx0PLE7Bpx4727HBW4ONLAt',
    addOnMax: 'price_1Sx0RdE7Bpx4727HrCEa0f8o'
  };

  // Lead capture for order form step 1
  function startLeadCaptureIfReady(){
    if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.start === 'function'){
      console.log('Lead capture loaded');
      window.LEAD_CAPTURE.start();
    }
  }
  // Ensure lead capture is loaded and ready to use
  function ensureLeadCaptureLoaded(){
    if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.start === 'function'){
      startLeadCaptureIfReady();
      return;
    }
    if (leadCaptureRequested){
      return;
    }
    leadCaptureRequested = true;
    var script = document.createElement('script');
    script.src = 'assets/js/leadCapture.js';
    script.async = true;
    script.onload = startLeadCaptureIfReady;
    script.onerror = function(){
      // allow retry on next call
      leadCaptureRequested = false;
    };
    document.head.appendChild(script);
  }

  function normalise(text){
    return text ? text.replace(/\s+/g, ' ').trim() : '';
  }

  function getStripePriceIdForPackageName(packageName) {
    // Keep PRICE_IDS keys camelCase; normalise incoming names from the DOM/storage.
    var name = normalise(packageName).toLowerCase();
    if (!name) { return null; }

    // Base packages
    if (name === 'basic' || name === 'standard' || name === 'max') {
      return PRICE_IDS[name] || null;
    }

    // Upgrades in markup are named like "Standard Upgrade" / "MAX Upgrade".
    // We intentionally keep PRICE_IDS keys camelCase and just normalise here.
    if (/\bupgrade\b/.test(name) && /\bstandard\b/.test(name)) {
      return PRICE_IDS.addOnStandard || null;
    }
    if (/\bupgrade\b/.test(name) && /\bmax\b/.test(name)) {
      return PRICE_IDS.addOnMax || null;
    }
    return null;
  }

  function savePackage(pkg){
    if (!pkg){ return; }
    try { localStorage.setItem(storageKey, JSON.stringify(pkg)); } catch(err){}
  }

  function loadPackage(){
    try {
      var raw = localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch(err){
      return null;
    }
  }

  function saveCustomer(customer){
    if (!customer){ return; }
    try { localStorage.setItem(customerStorageKey, JSON.stringify(customer)); } catch (err) {}
  }

  function loadCustomer(){
    try {
      var raw = localStorage.getItem(customerStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (err){
      return null;
    }
  }

  function saveOrderPayment(data){
    if (!data){ return; }
    try { localStorage.setItem(paymentStorageKey, JSON.stringify(data)); } catch (err) {}
  }

  function loadOrderPayment(){
    try {
      var raw = localStorage.getItem(paymentStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (err){
      return null;
    }
  }

  function getCheckoutMode(){
    try {
      var params = new URLSearchParams(window.location.search || '');
      var raw = params.get('mode');
      if (!raw){ return null; }
      var mode = String(raw).trim();
      return mode ? mode : null;
    } catch (err) {
      try {
        var fallbackMatch = (window.location.search || '').match(/[?&]mode=([^&#]+)/i);
        if (fallbackMatch && fallbackMatch[1]){
          var decoded = decodeURIComponent(fallbackMatch[1]);
          decoded = decoded ? decoded.trim() : '';
          return decoded || null;
        }
      } catch (e) {}
      return null;
    }
  }

  function collectCustomerFromStep1(){
    var firstName = $('#order-first-name').val();
    var lastName = $('#order-last-name').val();
    var email = $('#order-email').val();
    var phone = $('#order-phone').val();
    var company = $('#order-company').val();
    var country = $('#order-country').val();
    var jobTitle = $('#order-job-title').val();
    var source = $('#order-source').val();

    return {
      firstName: firstName || '',
      lastName: lastName || '',
      email: email || '',
      phone: phone || '',
      company: company || '',
      country: country || '',
      jobTitle: jobTitle || '',
      source: source || '',
      capturedAt: new Date().toISOString()
    };
  }

  function persistCustomerFromStep1(){
    saveCustomer(collectCustomerFromStep1());
  }

  function getPackageSummaryElements(){
    var $packageSummary = $('#step-1-form .package-summary, #step-3-form .package-summary');
    return {
      $title: $packageSummary.find('h3').first(),
      $summary: $packageSummary.find('.summary').first(),
      $price: $packageSummary.find('.price').first(),
      $taxNote: $packageSummary.find('.text-muted.small').first()
    };
  }

  function renderPackage(pkg){
    if (!pkg){
      return;
    }
    var els = getPackageSummaryElements();
    if (els.$title.length && pkg.name) els.$title.text(pkg.name);
    if (els.$summary.length && pkg.summary) els.$summary.text(pkg.summary);
    if (els.$price.length && pkg.price) els.$price.html(pkg.price);
    if (els.$taxNote.length){
      if (pkg.taxNote){
        els.$taxNote.text(pkg.taxNote).show();
      } else {
        els.$taxNote.text('').hide();
      }
    }
  }

  function setOrderStep(step){
    var $step1 = $('#step-1-form');
    var $step2 = $('#step-2-form');
    var $step3 = $('#step-3-form');

    $step1.hide();
    $step2.hide();
    $step3.hide();

    if (step === 1) {
      $step1.show();
    } else if (step === 2) {
      $step2.show();
    } else if (step === 3) {
      $step3.show();
    }
  }

  function showStep2State(state) {
    $('#step-2-loading').hide();
    $('#step-2-checkout').hide();
    $('#step-2-error').hide();

    if (state === 'loading') {
      $('#step-2-loading').show();
    } else if (state === 'checkout') {
      $('#step-2-checkout').show();
    } else if (state === 'error') {
      $('#step-2-error').show();
    }
  }

  function extractPackage($btn){
    var name = normalise($btn.attr('data-package-name'));
    var price = normalise($btn.attr('data-package-price'));
    if (!name || !price){ return null; }
    return {
      name: name,
      summary: normalise($btn.attr('data-package-summary')),
      price: price,
      taxNote: normalise($btn.attr('data-package-tax-note'))
    };
  }

  function updateDeadline(){
    var $deadline = $('#nudge-deadline strong');
    if (!$deadline.length){ return; }
    var deadline = new Date(Date.now() + (orderDeadlineHours * 60 * 60 * 1000));
    var dateStr = deadline.toLocaleDateString('en-GB', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'
    });
    var deadlineHours = deadline.getUTCHours();
    var deadlineMinutes = deadline.getUTCMinutes();
    var deadlineSeconds = deadline.getUTCSeconds();
    var ampm = deadlineHours >= 12 ? 'PM' : 'AM';
    var hours = deadlineHours % 12;
    hours = hours ? hours : 12;
    var minutes = deadlineMinutes < 10 ? '0' + deadlineMinutes : deadlineMinutes;
    var seconds = deadlineSeconds < 10 ? '0' + deadlineSeconds : deadlineSeconds;
    var timeStr = hours + ':' + minutes + ':' + seconds + ' ' + ampm + ' (UTC)';
    var formatted = dateStr + ' at ' + timeStr;
    $deadline.text(formatted);
  }

  function startDeadlineTimer(){
    litboxOpenTime = new Date();
    if (deadlineInterval){
      clearInterval(deadlineInterval);
      deadlineInterval = null;
    }
    updateDeadline();
    deadlineInterval = setInterval(function(){ updateDeadline(); }, 1000);
  }

  function stopDeadlineTimer(){
    if (deadlineInterval){
      clearInterval(deadlineInterval);
      deadlineInterval = null;
    }
    litboxOpenTime = null;
  }

  function handleOrderBeforeUnload(event){
    if (!isOrderLitboxOpen || forceLitboxClose){ return; }
    try {
      if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.sendNow === 'function'){
        window.LEAD_CAPTURE.sendNow({ ignoreInterval: true, lockSession: true });
      }
    } catch (e) {}
    event.preventDefault();
    event.returnValue = orderClosePrompt;
    return orderClosePrompt;
  }

  function bindOrderBeforeUnload(){
    if (orderBeforeUnloadBound){ return; }
    window.addEventListener('beforeunload', handleOrderBeforeUnload);
    orderBeforeUnloadBound = true;
  }

  function unbindOrderBeforeUnload(){
    if (!orderBeforeUnloadBound){ return; }
    window.removeEventListener('beforeunload', handleOrderBeforeUnload);
    orderBeforeUnloadBound = false;
  }

  pub.stopOrderDeadlineTimer = stopDeadlineTimer;

  function openOrderLitbox(pkg, step){
    // step = 3;// TEMP
    var targetSelector = (step === 3) ? '#step-3-form' : (step === 2) ? '#step-2-form' : '#step-1-form';
    var $target = $(targetSelector);
    if (!$target.length || typeof $.litbox !== 'function'){
      return;
    }

    var data = pkg || loadPackage();
    renderPackage(data);
    setOrderStep(step);
    if (step === 1){
      try {
        if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.resetSession === 'function'){
          window.LEAD_CAPTURE.resetSession({ regenerateId: false });
        }
      } catch (e) {}
      ensureLeadCaptureLoaded();
    }

    $.litbox({
      inline: true,
      href: targetSelector,
      title: data && data.name ? data.name + ' package' : 'Order',
      overlayClose: false,
      escKey: false,
      className: 'litbox-order',
      css: {
        xxs: { offset: 5, maxWidth: 900, width: '100%', opacity: 0.4 },
        sm: { offset: '5% 20px' }
      },
      onOpen: function(){
        isOrderLitboxOpen = true;
        bindOrderBeforeUnload();
        renderPackage(data);
        setOrderStep(step);
      },
      onComplete: function(){
        renderPackage(data);
        setOrderStep(step);
        if (!litboxOpenTime) { startDeadlineTimer(); } else { updateDeadline(); }
        if (step === 2) {
          paymentCompleted = false;
          $('#step-2-continue-wrapper').hide();
          $('#checkout-frame').show();
          showStep2State('loading');
          setTimeout(function(){ initializeStripeCheckout(); }, 100);
        }
      },
      onClose: function() {
        if (!forceLitboxClose && !confirm(orderClosePrompt)) {
          return false;
        }
        try {
          if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.sendNow === 'function'){
            window.LEAD_CAPTURE.sendNow({ ignoreInterval: true, lockSession: true });
          }
        } catch (e) {}
        isOrderLitboxOpen = false;
        unbindOrderBeforeUnload();
        forceLitboxClose = false;
        stopDeadlineTimer();
        if (step === 2) {
          try {
            var frame = document.getElementById('checkout-frame');
            if (frame) frame.src = 'about:blank';
          } catch (e) {}
          paymentCompleted = false;
          $('#step-2-continue-wrapper').hide();
          $('#checkout-frame').show();
        }
        return true;
      }
    });
  }

  function showStep1FormIfValid(e){
    e.preventDefault();
    var $form = $('#order-form-step-1');
    if (step1Validator && !$form.valid()) { return; }
    var formEl = $form[0];
    if (!step1Validator && formEl && typeof formEl.checkValidity === 'function' && !formEl.checkValidity()) {
      if (typeof formEl.reportValidity === 'function') {
        formEl.reportValidity();
      }
      return;
    }
    persistCustomerFromStep1();
    var pkg = loadPackage();
    var isLocal = MAIN.isLocalEnv();
    setOrderStep(2);
    try {
      if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.sendNow === 'function'){
        window.LEAD_CAPTURE.sendNow({ ignoreInterval: true, lockSession: true });
      }
    } catch (err) {}
    // Track Step 1 submission as we move to payment.
    if (!isLocal) {
      if (typeof gtag === 'function') {
        gtag('event', 'conversion', {
          send_to: 'AW-17850156138/9mgqCPDKpN0bEOqIz79C'
        });
      }
    }
    openOrderLitbox(pkg, 2);
  }

  function initializeStripeCheckout() {
    var pkg = loadPackage();
    if (!pkg) { showStep2State('error'); return; }

    // Strip any currency symbols / grouping and parse numeric value.
    var priceText = pkg.price.replace(/[^\d.,-]/g, '').replace(/,/g, '');
    var amount = parseFloat(priceText) * 100;
    if (isNaN(amount) || amount <= 0) { showStep2State('error'); return; }
    amount = Math.round(amount);

    var firstName = $('#order-first-name').val();
    var lastName = $('#order-last-name').val();
    var email = $('#order-email').val();
    var currency = 'gbp';
    try {
      currency = (LOCALE.getCurrency() || 'gbp').toLowerCase();
    } catch (err) {
      currency = 'gbp';
    }
    var paymentCurrency = (currency || 'gbp').toUpperCase();
    var priceId = null;
    try {
      priceId = getStripePriceIdForPackageName(pkg.name);
    } catch (e) {}
    var customerName = (firstName + ' ' + lastName).trim();
    var checkoutMode = getCheckoutMode();

    persistCustomerFromStep1();

    var makeEndpoint = window.MAKE_WEBHOOK_ENDPOINT || 'https://hook.eu1.make.com/nigdncuxzu4gzgdvv7rju5k993khg29w';

    try {
      var existingPayment = loadOrderPayment() || {};
      // Persist payment context so we have amount/currency alongside the package.
      saveOrderPayment($.extend({}, existingPayment, {
        name: pkg.name || existingPayment.name || null,
        price: pkg.price || existingPayment.price || null,
        amount: amount,
        currency: paymentCurrency,
        summary: pkg.summary || existingPayment.summary || null,
        taxNote: pkg.taxNote || existingPayment.taxNote || null,
        status: existingPayment.status || 'created',
        updatedAt: new Date().toISOString()
      }));
      sessionStorage.setItem('b48:checkoutContext', JSON.stringify({
        stripePublishableKey: STRIPE_PUBLISHABLE_KEY || null,
        makeEndpoint: makeEndpoint,
        email: email,
        name: customerName,
        amount: amount,
        currency: currency,
        priceId: priceId || null,
        mode: checkoutMode || null
      }));
    } catch (e) {}

    var frame = document.getElementById('checkout-frame');
    if (!frame) { showStep2State('error'); return; }

    showStep2State('loading');
    $('#step-2-continue-wrapper').hide();
    $('#checkout-frame').show();
    frame.onload = function() { showStep2State('checkout'); };
    frame.src = 'checkout.html?ts=' + Date.now();
  }

  function handlePaymentComplete() {
    paymentCompleted = true;
    var isLocal = MAIN.isLocalEnv();
    var payment = loadOrderPayment() || {};
    // Prefer the payment/intent id so Google can de-duplicate conversions.
    var orderId = payment.id || payment.paymentIntentId || payment.paymentId || ('local-' + Date.now());
    showStep2State('checkout');
    $('#checkout-frame').css('display', 'none').attr('hidden', 'hidden');
    $('#step-2-continue-wrapper').show();
    NAV.replaceQueryParam('order', 'success', { clearHash: false, removeIfFalsy: false });
    // Don't track conversions if we're on the local environment.
    if (!isLocal) {
      // Fire Google Ads conversion tracking event.
      if (typeof gtag === 'function') {
        gtag('event', 'conversion', {
          send_to: 'AW-17850156138/oECmCIfugNwbEOqIz79C',
          value: payment.amount / 100,
          currency: payment.currency,
          transaction_id: orderId
        });
      }
      // Fire Meta Pixel event.
      if (window.fbq) {
        var pkg = loadPackage() || {};
        fbq('track', 'Purchase', {
          value: payment.amount / 100,
          currency: payment.currency,
          contents: [{ id: pkg.name || 'Unknown product', quantity: 1 }],
          content_type: 'product'
        });
      }
    }
  }

  function handlePaymentSuccess() {
    var pkg = loadPackage();
    setOrderStep(3);
    openOrderLitbox(pkg, 3);
  }

  function handleTryAgain() {
    var pkg = loadPackage();
    setOrderStep(1);
    openOrderLitbox(pkg, 1);
  }

  pub.handlePaymentComplete = handlePaymentComplete;
  pub.handlePaymentSuccess = handlePaymentSuccess;
  pub.openOrderLitbox = openOrderLitbox;

  function ensurePaymentListener(){
    if (paymentListenerBound){ return; }
    paymentListenerBound = true;
    window.addEventListener('message', function(event) {
      try {
        if (!event || !event.data) return;
        var type = event.data.type;
        if (type === 'b48:paymentComplete'){
          handlePaymentComplete();
          return;
        }
        if (type === 'b48:orderPayment'){
          var current = loadOrderPayment() || {};
          var incomingId = event.data.id || event.data.paymentId || event.data.paymentIntentId || null;
          var next = $.extend({}, current, {
            provider: event.data.provider || current.provider || null,
            id: incomingId || current.id || current.paymentIntentId || null,
            status: current.status || 'created',
            updatedAt: new Date().toISOString()
          });
          saveOrderPayment(next);
          return;
        }
        if (type === 'b48:orderPaymentStatus'){
          var current2 = loadOrderPayment() || {};
          var next2 = $.extend({}, current2, {
            provider: event.data.provider || current2.provider || null,
            id: current2.id || current2.paymentIntentId || null,
            status: event.data.status || current2.status || null,
            updatedAt: new Date().toISOString()
          });
          saveOrderPayment(next2);
          return;
        }
      } catch (e) {
        // ignore
      }
    });
  }

  function bindUiHandlers(){
    if (uiBound){ return; }
    uiBound = true;

    $(document).on('click', '.order-trigger', function(e){
      e.preventDefault();
      var $btn = $(this);
      var pkg = extractPackage($btn);
      var desiredStep = parseInt($btn.attr('data-order-step'), 10);
      if (pkg){ savePackage(pkg); }
      openOrderLitbox(pkg, desiredStep === 2 ? 2 : 1);
    });

    $(document).on('submit', '#order-form-step-1', showStep1FormIfValid);

    $(document).on('click', '#step-2-try-again', function(e) {
      e.preventDefault();
      handleTryAgain();
    });

    $(document).on('click', '#step-2-continue', function(e) {
      e.preventDefault();
      if (!paymentCompleted) { return; }
      handlePaymentSuccess();
    });

    $(document).on('click', '.trigger-litbox-final-close', function(e){
      e.preventDefault();
      forceLitboxClose = true;
      try {
        if ($.litbox && typeof $.litbox.close === 'function'){
          $.litbox.close();
          // remove all query strings from the URL
          window.history.replaceState({}, document.title, window.location.pathname);
          // reload the page for a fresh start
          window.location.reload();
        }
      } catch (err) {}
    }); 
  }

  function orderFlow(){
    paymentCompleted = false;
    forceLitboxClose = false;
    isOrderLitboxOpen = false;
    orderBeforeUnloadBound = false;
    stopDeadlineTimer();

    step1Validator = (window.FORMS && typeof FORMS.setupValidation === 'function') ? FORMS.setupValidation($('#order-form-step-1'), {
      onfocusout: function(element){ $(element).valid(); },
      onkeyup: false
    }) : null;

    renderPackage(loadPackage());
    setOrderStep(1);

    ensurePaymentListener();
    bindUiHandlers();

    try {
      if (STRIPE_PUBLISHABLE_KEY) {
        localStorage.setItem('b48:stripePublishableKey', STRIPE_PUBLISHABLE_KEY);
      }
    } catch (e) {}
  }

  $(function(){
    orderFlow();
  });

  return pub;
})(jQuery, window, document);
